var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lateness" },
    [
      _c(
        "div",
        { staticClass: "lateness-header" },
        [
          _c("c-input", {
            staticClass: "lateness-header-posts",
            attrs: {
              type: "select",
              placeholder: "Должности",
              multiple: true,
              items: _vm.postsLocalItems,
            },
            model: {
              value: _vm.postLocalValues,
              callback: function ($$v) {
                _vm.postLocalValues = $$v
              },
              expression: "postLocalValues",
            },
          }),
          _c("c-switcher", {
            staticClass: "lateness-header-posts-mobile",
            attrs: {
              type: "group",
              items: [
                { icon: "operator", value: "operator" },
                { icon: "administrator", value: "administrator" },
                { icon: "sushi", value: "suhi" },
                { icon: "pizza", value: "pizzamaker" },
                { icon: "hot", value: "hot" },
                { icon: "driver", value: "driver" },
              ],
            },
            model: {
              value: _vm.latenessLocalValueMobile,
              callback: function ($$v) {
                _vm.latenessLocalValueMobile = $$v
              },
              expression: "latenessLocalValueMobile",
            },
          }),
          _c("c-switcher", {
            staticClass: "lateness-header-posts-tablet",
            attrs: {
              type: "group",
              items: [
                { label: "Операторы", value: "operator" },
                { label: "Администраторы", value: "administrator" },
                { label: "Сушисты", value: "suhi" },
                { label: "Пиццемейкеры", value: "pizzamaker" },
                { label: "Горячий цех", value: "hot" },
                { label: "Водители", value: "driver" },
              ],
            },
            model: {
              value: _vm.latenessLocalValueTablet,
              callback: function ($$v) {
                _vm.latenessLocalValueTablet = $$v
              },
              expression: "latenessLocalValueTablet",
            },
          }),
          _c("c-input", {
            staticClass: "lateness-header-lateness",
            attrs: {
              type: "select",
              placeholder: "Степень опоздания",
              clearable: true,
              items: _vm.latenessLocalItems,
            },
            model: {
              value: _vm.latenessLocalValue,
              callback: function ($$v) {
                _vm.latenessLocalValue = $$v
              },
              expression: "latenessLocalValue",
            },
          }),
        ],
        1
      ),
      !_vm.dataIsLoading
        ? _c("c-data-table-create-calculations-tabs", {
            ref: "table",
            staticClass: "lateness-table",
            class: {
              "lateness-table-layout-fixed": _vm.postLocalValues.length === 1,
            },
            attrs: {
              levels: 2,
              disabledColumns: [],
              data: _vm.tableData,
              calcData: _vm.data,
              "can-edit": _vm.canEdit,
            },
          })
        : _vm._e(),
      _vm.dataIsLoading
        ? _c("c-loader", {
            staticClass: "lateness-loader",
            attrs: {
              label: "Данные загружаются",
              active: _vm.dataIsLoading,
              height: "300",
            },
          })
        : _vm._e(),
      _vm.canEdit || _vm.canClose || _vm.isClosed
        ? _c(
            "div",
            { staticClass: "lateness-buttons-row" },
            [
              _vm.canClose
                ? _c("c-button", {
                    staticClass: "lateness-toggle-closed",
                    class: { "lateness-toggle-closed--active": !_vm.isClosed },
                    attrs: {
                      size: "large",
                      disabled: _vm.isTogglingClosed,
                      label: _vm.isClosed ? "Открыть расчёт" : "Закрыть расчёт",
                      color: _vm.isClosed ? "primary" : undefined,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("toggleClosed")
                      },
                    },
                  })
                : _vm._e(),
              _vm.isClosed
                ? _c("span", { staticClass: "lateness-closed-badge" }, [
                    _vm._v("Расчёт закрыт"),
                  ])
                : _vm._e(),
              _vm.canEdit
                ? _c(
                    "div",
                    { staticClass: "lateness-buttons" },
                    [
                      _c("c-button", {
                        staticClass: "lateness-buttons-cancel",
                        attrs: { label: "Отменить", color: "white" },
                      }),
                      _c("c-button", {
                        staticClass: "lateness-buttons-save",
                        attrs: { label: "Сохранить", color: "primary" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }